import { OrganizationScrapedImageState } from './organization-scraped-image-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  updateResourceByParam,
  deleteResourceByParam,
} from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState: OrganizationScrapedImageState = {
  organizationScrapedImagesById: {},
  organizationScrapedImagesStateByOrgId: {},
};

export const organizationScrapedImageReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_ORGANIZATION_SCRAPED_IMAGES'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'organizationScrapedImages', 'orgId', orgId, true);
    }
    case SUCCESS('LOAD_ORGANIZATION_SCRAPED_IMAGES'): {
      const {
        args: { orgId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'organizationScrapedImages',
        'orgId',
        orgId,
        false,
        convertArrayToMap(data, (d: OrganizationScrapedImage) =>
          String(d.organizationScrapedImageId),
        ),
      );
    }
    case FAILURE('LOAD_ORGANIZATION_SCRAPED_IMAGES'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'organizationScrapedImages', 'orgId', orgId, false);
    }
    case SUCCESS('UPDATE_ORGANIZATION_SCRAPED_IMAGE'): {
      const {
        args: { update },
        data,
      } = action.payload;
      const { organizationScrapedImageId, orgId } = data;

      if (update.deletedAt) {
        return deleteResourceByParam(
          state,
          'organizationScrapedImages',
          'orgId',
          orgId,
          organizationScrapedImageId,
        );
      }

      return updateResourceByParam(state, 'organizationScrapedImages', 'orgId', orgId, false, {
        [organizationScrapedImageId]: data,
      });
    }
    default: {
      return state;
    }
  }
};
